<script>
export default {
  name: 'BarocareConciSubSnb',
  props: {
    currentPath: {
      type: String,
      default: '',
    },
  },
  created() {
    // 컴포넌트가 생성될 때 필요한 로직이 있다면 나중에 추가
  },
  methods: {
    // 필요한 methods 있으면 나중에 추가
  }
}
</script>

<template>
<div class="left-sidebar">
  <nav class="navigation">
    <ul>
      <li>
        <router-link to="/barocarenew">메인으로</router-link>
      </li>
<!--      <li :class="{ select: currentPath.includes('/barocarenew/sub2') }">-->
<!--        <router-link to="/barocarenew/sub2">서비스 소개</router-link>-->
<!--      </li>-->
      <li>
        <a class="cta_001" href="https://bit.ly/soldoc_introduction" target="_blank">서비스 소개</a>
      </li>
      <li :class="{ select: currentPath.includes('/barocarenew/sub3') }">
        <router-link to="/barocarenew/sub3">이용방법</router-link>
      </li>
      <li :class="{ select: currentPath.includes('/barocarenew/sub1') }">
        <router-link to="/barocarenew/sub1">구매 가능 품목</router-link>
      </li>
      <li :class="{ select: currentPath.includes('/barocarenew/sub5') }">
        <router-link to="/barocarenew/sub5">인슐린 약국 지도</router-link>
      </li>
      <li :class="{ select: currentPath.includes('/barocarenew/sub4') }">
        <router-link to="/barocarenew/sub4">자주 묻는 질문</router-link>
      </li>
    </ul>
  </nav>
</div>
</template>

<style lang="scss">
.left-sidebar {
  position: fixed;
  top: 110px;
  height: calc(100vh - 40px);
  overflow-y: auto;
  align-self: flex-start;
  margin-right: 20px;
  width: 236px;

  li {
    height: 52px;
    border-radius: 10px;
    font-weight: 400;
    font-size: 18px;
    line-height: 52px;
    letter-spacing:  -0.002rem;
    text-decoration: none;
    padding-left: 11px;

    &:hover {
      // background: #e1f2ff;
    }

    a {
      display: block;
      text-decoration: none;
      &:hover {
        color: #000;
      }
    }

    &.select {
      background: #e1f2ff;
      font-weight: 600;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciSubSnb.vue